export enum UserRole {
  UserAdmin = 'userAdmin',
  BusinessAreaAdmin = 'businessAreaAdmin',
  BusinessAreaCreator = 'businessAreaCreator',
  BusinessAreaEraser = 'businessAreaEraser',
  ContentAdmin = 'contentAdmin',
  AnyViewer = 'anyViewer',
}
